// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"176":"a48d746a","294":"c5a7d737","470":"6d3de6b2","722":"ff86bad8"}[chunkId] + ".chunk.css";
};